import React from 'react';

import Modal from 'react-modal';
import { Accordion, AccordionTab } from 'primereact/accordion';
import { CircularProgress } from "@material-ui/core";
import ReactPlayer from 'react-player'

import { useModal } from 'hooks/modal';

function Helper() {
  const {
    modalVisible,
    data,
    loading,
    setModalVisible,
    helperId
  } = useModal();

  const customStyles = {
    content : {
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      width: '60%',
      minHeight: '70%',
    },
    overlay: {
      overflow: 'auto',
      transition: '(top 0.4s, opacity 0.4s)',
      zIndex: 100000,
      background: 'rgba(0, 0, 0, 0.4)',
    }
  };
  
  return (
    <Modal
      isOpen={modalVisible}
      style={customStyles}
      onRequestClose={() => setModalVisible(false)}
      shouldCloseOnOverlayClick
      ariaHideApp={false}
    > 
    {!loading ? 
      <>
      {data.id ? 
        <>
          <h3>{data.title}</h3>
          <span 
            onClick={() => setModalVisible(false)} 
            style={{
              fontSize: 30, 
              cursor: 'pointer',
              position: 'absolute',
              right: '1%',
              top: '1%'
            }}
          >
            <i className="fas fa-times"></i>
          </span>
          {(data.video || data.youtube) && 
            <ReactPlayer 
              width="100%"
              height="60%"
              url={data.video || 'youtube.com/watch?v=' + data.youtube}
              controls 
              style={{marginBottom: 15}}
            />
          }
          <Accordion activeIndex={0}>
            {data.HelpContents && data.HelpContents.map((data, index) => (
                <AccordionTab header={data.title}>
                  <div  dangerouslySetInnerHTML={{
                    __html: data.text
                  }}/>
                </AccordionTab>
            ))} 
          </Accordion>
        </>
      :
        <>
          <span 
            onClick={() => setModalVisible(false)} 
            style={{
              fontSize: 30, 
              cursor: 'pointer',
              position: 'absolute',
              right: '1%',
              top: '1%'
            }}
          >
            <i className="fas fa-times"></i>
          </span>
          <h3>Nenhum dado encontrado para o ID {helperId}.</h3>
        </>
      }
      </>
      :
        <div 
          style={{
            width: '100%', 
            height: '100%', 
            display: 'flex', 
            justifyContent: 'center', 
            alignItems: 'center'
          }}
        >
          <CircularProgress />
        </div>
      }
    </Modal>
  );
}

export default Helper;